// src/components/ConsentModal.jsx
import React from "react";
import Button from "@/components/ui/Button";

export default function ConsentModal({ open, onCancel, onAccept }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-[rgb(var(--clr-surface-cont-highest))] p-6 shadow-[0_8px_24px_rgba(16,24,40,0.12)] text-center">
        <h3 className="text-title-medium text-on-surface">
          Scan & store your document
        </h3>
        <p className="mt-2 text-body-medium text-on-surface-var leading-relaxed">
          By uploading a copy of your ID/passport we’ll store it securely for
          verification. The image is encrypted, kept for <b>90 days</b>, and{" "}
          <b>cannot be deleted earlier</b>. Maximum file size <b>500 KB</b>. You
          can request an export or raise questions with support.
        </p>

        <div className="mt-6 flex justify-center gap-3">
          <Button
            variant="secondary"
            className="bg-[rgba(248,83,58,0.12)] text-[#F8533A] hover:bg-[rgba(248,83,58,0.18)] px-6"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={onAccept}
            className="bg-[rgba(86,106,139,0.08)] text-[rgb(var(--afrimed-primary))] hover:bg-[rgba(86,106,139,0.12)] px-6"
          >
            I Agree & Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
